(function($){
  
    $(function() {
  
      var blocquestions = $('#js--test-questions');
      var blocresultat = $('#js--test-resultat');
      var VoirResultat = $('#js--VoirResultat');


      /* list brochure
      groupe_a : Arrêter le tabac sans ombrage
      groupe_b : Booster la mémoire et la concentration
      groupe_c : Comprendre le stress
      groupe_d : Retrouver un bon sommeil
      groupe_e : Éviter le grignotage
      groupe_f : Faire face à un stress ponctuel
      groupe_g : Gérer un effort sportif
      groupe_h : Passer un examen
      */


      //BROCHURE
      var brochureGroupe_a = $('#js--groupe_a--brochure');
      var brochureGroupe_b = $('#js--groupe_b--brochure');
      var brochureGroupe_c = $('#js--groupe_c--brochure');
      var brochureGroupe_d = $('#js--groupe_d--brochure');
      var brochureGroupe_e = $('#js--groupe_e--brochure');
      var brochureGroupe_f = $('#js--groupe_f--brochure');
      var brochureGroupe_g = $('#js--groupe_g--brochure');
      var brochureGroupe_h = $('#js--groupe_h--brochure');
      var toutesBrochures = $('#js--groupe_a--brochure, #js--groupe_b--brochure, #js--groupe_c--brochure, #js--groupe_d--brochure, #js--groupe_e--brochure, #js--groupe_f--brochure, #js--groupe_g--brochure, #js--groupe_h--brochure');
      
      //TEXTE
      var textNul            = $('#js--nul');
      var textfaible         = $('#js--faible');
      var textmoyen          = $('#js--moyen');
      var textimportant      = $('#js--important');
      var texttres_important = $('#js--tres_important');

      
      
      // on cache les éléments
      $('#js--nul, #js--faible, #js--moyen, #js--important, #js--tres_important').css('display','none');
      toutesBrochures.css('display','none');
      
      

      if ( blocquestions[0] ) {
        
        VoirResultat.on('click', function(event){
          var cochee =  $('input[type="checkbox"]:checked');
          var cocheeNbr = cochee.length
          // console.log(cocheeNbr+"coché");
          
          blocresultat.css('display','block');
          blocquestions.css('display','none');
          
          //on affiche le texte resultat
          if ( (cocheeNbr === 0) ) {
            textNul.css('display','block');
            var debutTitre = $('.js--titre--result1').text();
          } 
          else if ( (cocheeNbr >= 1) && (cocheeNbr <= 5) ) {
            textfaible.css('display','block');
            var debutTitre = $('.js--titre--result2').text();
          } 
          else if ( (cocheeNbr >= 6) && (cocheeNbr <= 15) ) {
            textmoyen.css('display','block');
            var debutTitre = $('.js--titre--result3').text();
          } 
          else if ( (cocheeNbr >= 11) && (cocheeNbr <= 15) ) {
            textimportant.css('display','block');
            var debutTitre = $('.js--titre--result4').text();
          } 
          else if ( (cocheeNbr >= 16) ) {
            texttres_important.css('display','block');
            var debutTitre = $('.js--titre--result5').text();
          }

          //ON AFFICHE LE RESULTAT DU TEST EN HAUT
          $('.js--titre-resultat').text(debutTitre);        


          //on affiche le programe coach
          // if ( (cochee.length >= 2) && (cochee.length <= 20) ) {
          //   texttres_important.css('display','block');
          // } 


          $('#js--test-resultat #js--titre-resultat').appendTo('BRAVO');


          //Programme proposé
          $('.test-resultat__titre--filet').css('display','none');
          $('.js--brochure').css('display','none');
          $('#js--besoin *').css('display','none');

          var beneficeA = $('input[data-benefice="groupe_a"]:checked').length;
          if(beneficeA >= 2){
            brochureGroupe_a.css('display','block');
            $('#js--besoin .test-resultat__titre').css('display','block');
            $('#js--besoin ul').css('display','block');
            $('#js--besoin .groupe_a').css('display','block');
            $('.test-resultat__titre--filet').css('display','block');
          }

          var beneficeB = $('input[data-benefice="groupe_b"]:checked').length;
          if(beneficeB >= 2){
            brochureGroupe_b.css('display','block');
            $('#js--besoin .test-resultat__titre').css('display','block');
            $('#js--besoin ul').css('display','block');
            $('#js--besoin .groupe_b').css('display','block');
            $('.test-resultat__titre--filet').css('display','block');
          }

          var beneficeC = $('input[data-benefice="groupe_c"]:checked').length;
          if(beneficeC >= 2){
            brochureGroupe_c.css('display','block');
            $('#js--besoin .test-resultat__titre').css('display','block');
            $('#js--besoin ul').css('display','block');
            $('#js--besoin .groupe_c').css('display','block');
            $('.test-resultat__titre--filet').css('display','block');
          }

          var beneficeD = $('input[data-benefice="groupe_d"]:checked').length;
          if(beneficeD >= 2){
            brochureGroupe_d.css('display','block');
            $('#js--besoin .test-resultat__titre').css('display','block');
            $('#js--besoin ul').css('display','block');
            $('#js--besoin .groupe_d').css('display','block');
            $('.test-resultat__titre--filet').css('display','block');
          }

          var beneficeE = $('input[data-benefice="groupe_e"]:checked').length;
          if(beneficeE >= 2){
            brochureGroupe_e.css('display','block');
            $('#js--besoin .test-resultat__titre').css('display','block');
            $('#js--besoin ul').css('display','block');
            $('#js--besoin .groupe_e').css('display','block');
            $('.test-resultat__titre--filet').css('display','block');
          }

          var beneficeF = $('input[data-benefice="groupe_f"]:checked').length;
          if(beneficeF >= 2){
            brochureGroupe_f.css('display','block');
            $('#js--besoin .test-resultat__titre').css('display','block');
            $('#js--besoin ul').css('display','block');
            $('#js--besoin .groupe_f').css('display','block');
            $('.test-resultat__titre--filet').css('display','block');
          }

          var beneficeG = $('input[data-benefice="groupe_g"]:checked').length;
          if(beneficeG >= 2){
            brochureGroupe_g.css('display','block');
            $('#js--besoin .test-resultat__titre').css('display','block');
            $('#js--besoin ul').css('display','block');
            $('#js--besoin .groupe_g').css('display','block');
            $('.test-resultat__titre--filet').css('display','block');
          }

          var beneficeH = $('input[data-benefice="groupe_h"]:checked').length;
          if(beneficeH >= 2){
            brochureGroupe_h.css('display','block');
            $('#js--besoin .test-resultat__titre').css('display','block');
            $('#js--besoin ul').css('display','block');
            $('#js--besoin .groupe_h').css('display','block');
            $('.test-resultat__titre--filet').css('display','block');
          }


        });

      }
  
    });
  
  })(jQuery);